module.exports = __webpack_public_path__ + "static/img/KHK工厂介绍.mp4.410406c3.jpg";